/**
 * PAN-639: one place that says which base a frozen goal was set against, and
 * whether the book has moved since. Used by the goals modal (slider cards) and
 * the breakdown modal (Renewals / Expansion / Pilots), so a set-time number and
 * a now-number are never shown without saying which is which.
 */

// { base, setAt, live } for a frozen (non-estimated) goal; `live` is null when
// there is no live base to compare or it matches the set-time base to the cent.
// Null when the bucket has no goal or its goal is an estimate (then the base IS
// the live one and needs no provenance).
export const frozenBaseInfo = (nrrProgress, bucket) => {
  const obj = nrrProgress?.[bucket];
  const goal = obj?.goal;
  // A carried goal's base and date are today's, not a set-time snapshot.
  if (!goal || obj.estimated || goal.source === "carried") return null;
  const base =
    goal.base_mrr_at_set == null ? NaN : Number(goal.base_mrr_at_set);
  if (!Number.isFinite(base)) return null;
  const liveRaw = obj.live_base_mrr;
  const live = liveRaw == null ? NaN : Number(liveRaw);
  const moved = Number.isFinite(live) && Math.abs(live - base) >= 0.005;
  return { base, setAt: goal.set_at, live: moved ? live : null };
};

export const formatSetDate = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        timeZone: "UTC",
      });
};

/**
 * "<label> when the goal was set (26 Sept): $142 · now $233".
 * The "· now" suffix renders only when the base has moved. `onlyWhenMoved`
 * hides the whole line when it has not (the goals modal, where an unchanged
 * base would just repeat the "of $X" beside it).
 */
export const FrozenBaseLine = ({
  nrrProgress,
  bucket,
  label,
  sym,
  fmt,
  annualize = (v) => v,
  onlyWhenMoved = false,
  className,
}) => {
  const info = frozenBaseInfo(nrrProgress, bucket);
  if (!info || (onlyWhenMoved && info.live === null)) return null;
  return (
    <span className={className}>
      {label} when the goal was set
      {formatSetDate(info.setAt) ? ` (${formatSetDate(info.setAt)})` : ""}:{" "}
      <strong>
        {sym}
        {fmt(annualize(info.base))}
      </strong>
      {info.live !== null && (
        <>
          {" "}
          · now{" "}
          <strong>
            {sym}
            {fmt(annualize(info.live))}
          </strong>
        </>
      )}
    </span>
  );
};
